<template >
  <div class="" style="background: white;">
    <div class="row MobileHide" style="">
    <div class="col-5" style="text-align: center;">
      <img :src="httpReq + '/player/logo/' + id" alt="" style="margin-top: 20px; width: 150px;"> <br>     
      <h6 class="" style="color: green; text-align: center; margin-top: 5px; font-weight: 600;"> <span class="col" style=""> {{player.commonName}} </span></h6> 
    </div>
    <div class="col container" style="margin-top: 10px; text-align: left;">
      <div>
        <div style="">
        <ul style="list-style-type: none;">
        <li class="col" style="background: green; color: white; font-weight: 550;"> PROFILE </li> 
        <li class=""> <span class="" style="color: green;  "> Country: </span> <span class="col" style="" v-if="player.country"> {{player.country.name}} </span></li> 
        <li class="bbg"> <span class="" style="color: green;  "> Team: </span> <span class="col" style="" v-if="player.team"><router-link  style="" id="router-link" :to="{ name: 'teamPagePar', params: { id: player.team.id, name: player.team.name } }">{{player.team.name}} </router-link> </span></li> 
        <li class=""> <span class="" style="color: green;  "> Age: </span> <span class="col" style="" v-if=" player.birthdate"> {{new Date().getFullYear() - player.birthdate.slice(0,4)}} years</span></li> 
        <li class="bbg"> <span class="" style="color: green;  "> Height: </span> <span class="col" style="" v-if="player.height"> {{player.height}} </span></li> 
        <li class=""> <span class="" style="color: green;  "> Weight: </span> <span class="col" style="" v-if="player.weight"> {{player.weight}} </span></li> 
        <li class="bbg"> <span class="" style="color: green;  "> Birth: </span> <span class="col" style="" v-if="player.birthPlace"> {{player.birthPlace}} </span></li> 
        <li class=""> <span class="" style="color: green;  "> Birthdate: </span> <span class="col" style="" v-if="player.birthdate"> {{player.birthdate}} </span></li> 
        </ul>
        </div>
    </div>
    </div>
    </div>
    <div v-if="statistics.length > 0" class="container MobileHide">
            <span class="row" style="background: green; font-weight: 550; color: white;"> <span class="col mr-0 pr-0">TORUNAMENT</span>  <span class="col-2 ml-0 pl-0 mr-0 pr-0">TEAM</span> <span class="col-1 ml-0 pl-0"><img style="width: 15px; margin-bottom: 2px;" src="@/assets/goalBig.png"> </span> <span class="col-1 ml-0 pl-0"><img style="width: 15px; margin-bottom: 2px;" src="@/assets/yellowcardBig.png"/></span> <span class="col-1 ml-0 pl-0"><img style="width: 15px; margin-bottom: 2px;" src="@/assets/redCardBig.png" /></span> <span class="col-1 ml-0 pl-0 ">PASS</span></span>
          <ul style="list-style-type:none; padding-left: 0;">
            <li v-for="(some, ind) in kek" :key="ind" style="" class="row" v-bind:class="{bbg: ind % 2 == 1}"> 
              <span class="col mr-0 pr-0">{{some[0].season.tournament.name}} <span style="font-size: 11px;">{{some[0].season.name}}</span> </span>  
              <span class="col-2 ml-0 pl-0 mr-0 pr-0"><img :src="'https://sportapi.zuniac.com/team/logo/' + some[0].team.id " style="width: 20px; margin-right: 2px;" alt="">{{some[0].team.shortCode}}</span> 
              <span class="col-1 ml-0 pl-0" v-if="some[0].goal">{{some[0].goal}}</span><span class="col-1 ml-0 pl-0" v-else>-</span> 
              <span class="col-1 ml-0 pl-0" v-if="some[1]"><span v-if="some[1].yellowCard">{{some[1].yellowCard}}</span> <span v-else>-</span> </span><span class="col-1 ml-0 pl-0" v-else>-</span> 
              <span class="col-1 ml-0 pl-0" v-if="some[1]"><span v-if="some[1].redCard">{{some[1].redCard}}</span> <span v-else>-</span></span><span class="col-1 ml-0 pl-0" v-else>-</span> 
              <span class="col-1 ml-0 pl-0" v-if="some[1]"><span v-if="some[1].assist">{{some[1].assist}}</span> <span v-else>-</span></span><span class="col-1 ml-0 pl-0" v-else>-</span> 
            </li>
          </ul>
    </div>
    <div class="MobileShow">
    <div class="col" style="text-align: center;"><img :src="httpReq + '/player/logo/' + id" alt="" style="margin-top: 10px; width: 150px;"></div>
    <h4 class="" style="color: green; text-align: center; margin-top: 5px; font-weight: 600;"> <span class="col" style=""> {{player.commonName}} </span></h4> 
    <div class="col" style="margin-top: 20px;">
      <div>
      <b-tabs content-class="mt-3" style=""
      active-nav-item-class="text-white bg-success" 
      justified>
        <b-tab title="PROFILE" active style="">
        <div style="">
        <ul style="list-style-type: none; padding-left: 0px;">
        <li class="bbg"> <span class="" style="color: green;  "> Country: </span> <span class="col" style="" v-if="player.country"> {{player.country.name}} </span></li> 
        <li class=""> <span class="" style="color: green;  "> Team: </span> <span class="col" style="" v-if="player.team"><router-link  style="" id="router-link" :to="{ name: 'teamPagePar', params: { id: player.team.id, name: player.team.name } }">{{player.team.name}} </router-link> </span></li> 
        <li class="bbg"> <span class="" style="color: green;  "> Age: </span> <span class="col" style="" v-if=" player.birthdate"> {{new Date().getFullYear() - player.birthdate.slice(0,4)}} years</span></li> 
        <li class=""> <span class="" style="color: green;  "> Height: </span> <span class="col" style="" v-if="player.height"> {{player.height}} </span></li> 
        <li class="bbg"> <span class="" style="color: green;  "> Weight: </span> <span class="col" style="" v-if="player.weight"> {{player.weight}} </span></li> 
        <li class=""> <span class="" style="color: green;  "> Birth: </span> <span class="col" style="" v-if="player.birthPlace"> {{player.birthPlace}} </span></li> 
        <li class="bbg"> <span class="" style="color: green;  "> Birthdate: </span> <span class="col" style="" v-if="player.birthdate"> {{player.birthdate}} </span></li> 
        </ul>
        </div>
        </b-tab>
        <b-tab title="STATISTICS" v-if="statistics.length > 0">
          <div>
           <span class="row" style="background: green; font-weight: 550; color: white;"> <span class="col-6 mr-0 pr-0 ml-0 pl-1">TORUNAMENT</span>  <span style="text-align: center;" class="col ml-0 pl-1 ">T</span> <span class="col ml-0 pl-0"><img style="width: 15px; margin-bottom: 2px;" src="@/assets/goalBig.png"> </span> <span class="col ml-0 pl-0"><img style="width: 15px; margin-bottom: 2px;" src="@/assets/yellowcardBig.png"/></span> <span class="col ml-0 pl-0"><img style="width: 15px; margin-bottom: 2px;" src="@/assets/redCardBig.png" /></span> <span class="col ml-0 pl-0 ">A</span></span>
          <ul style="list-style-type:none; padding-left: 0;">
            <li v-for="(some, ind) in kek" :key="ind" style="" class="row" v-bind:class="{bbg: ind % 2 == 1}"> <span class="col-6 mr-0 pr-0 ml-0 pl-1">{{some[0].season.tournament.name}} </span>  
            <span class="col ml-0 pl-1 "><img :src="'https://sportapi.zuniac.com/team/logo/' + some[0].team.id " style="width: 20px; margin-right: 2px;" alt=""></span> 
            <span class="col ml-0 pl-0"  v-if="some[0].goal">{{some[0].goal}}</span> <span class="col ml-0 pl-0" v-else>-</span>
            <span class="col ml-0 pl-0"  v-if="some[1]"><span v-if="some[1].yellowCard">{{some[1].yellowCard}}</span> <span v-else>-</span></span> <span class="col ml-0 pl-0" v-else>-</span>
            <span class="col ml-0 pl-0"  v-if="some[1]"><span v-if="some[1].redCard">{{some[1].redCard}}</span> <span v-else>-</span></span> <span class="col ml-0 pl-0" v-else>-</span>
            <span class="col ml-0 pl-0"  v-if="some[1]"><span v-if="some[1].assist">{{some[1].assist}}</span> <span v-else>-</span></span> <span class="col ml-0 pl-0" v-else>-</span>
            </li>
          </ul>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    </div>
    </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'PlayerPage',
    data(){
      return{
        cookiesObject: '',
        player: '',
        id: '',
        statistics: '',
        kek: '',
        }
  },

   mounted(){
    this.id = this.$route.params.id;

    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    var myHeaders = new Headers();
    myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

    var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };

    fetch(this.httpReq+"/player/" + this.id + "?token="+cookiesObject.token, requestOptions)
    .then(response => response.json())
    .then(result => {
        this.player = result.player;
        this.statistics = result.player.topScorers;
        // console.log(result)

        let group = result.player.topScorers.reduce((r, a) => {
        r[a.season.id] = [...r[a.season.id] || [], a];
        return r;
        }, {});
        this.kek = group;
        })
    .catch(error => console.log('error', error));

    },  

  props: {
  },
  computed:{
    ...mapGetters(['httpReq']),
  },

  watch: {
  
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bbg{
  background: #d6d6d6;
}

@media only screen and (max-width: 770px) {
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
